import React, { useState, useEffect } from "react"
import LanguageToggle from "../header/LanguageToggle"
import NavLink from "../NavLink"
import { useStaticQuery, graphql, Link } from "gatsby"

const Footer = () => {
  const allData = useStaticQuery(graphql`
    query {
      allNavFooterMenuJson {
        edges {
          node {
            name
            submenu {
              name
              title
              slug
            }
          }
        }
      }
    }
  `)
  const data = allData.allNavFooterMenuJson.edges
  const [date, setDate] = useState(null)

  useEffect(() => {
    setDate(new Date().getFullYear())
  }, [])
  if (data.length <= 0) {
    return <></>
  }
  return (
    <footer id="supports">
      <section className="bg-india-green support-block">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-4 col-md-12">
              <div className="section_title text-white">24/7 Support</div>
            </div>
            <div className="col-12 col-lg-8 col-md-12">
              <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-evenly gap-3">
                {/*  <div className="d-flex">
                  <i className="bi bi-chat-left-text-fill text-white me-3"></i>
                  <div className="">
                    <div className="text-white section_subtitle">Live Chat</div>
                    <div className="text-white section_content">Anytime</div>
                  </div>
                </div>*/}
                <a
                  href="tel:+919884824733"
                  className="text-decoration-none d-flex "
                >
                  <i className="bi bi-telephone-outbound text-white me-3"></i>
                  <div className="">
                    <div className="text-white section_subtitle">WhatsApp Support</div>
                    <div className="text-white section_content">24/7</div>
                    <div className="text-white section_content">
                      <span> +91 988-482-4733</span>
                      <img
                        src="/img/icons/india-flag.png"
                        alt="India"
                        title="India"
                        className="ms-1"
                        height={22}
                      />
                    </div>
                  </div>
                </a>
                <a
                  href="mailto:support@motherhost.com"
                  className=" text-decoration-none d-flex "
                >
                  <i className="bi bi-envelope text-white me-3"></i>
                  <div className="">
                    <div className="text-white section_subtitle">Email us</div>
                    <div className="text-white section_content">24/7</div>
                    <div className="text-white section_content">
                      support@motherhost.com
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-dark pb-0 border-bottom border-white">
        <div className="container-fluid ">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <div className="text-white mb-2">
                Keep yourself informed with top-notch content by subscribing to
                our motherhost newsletter. Receive our valuable updates,
                including industry news, articles, and recent developments,
                delivered straight to your inbox. Stay up-to-date effortlessly
                by subscribing today!
              </div>
              <script
                type="text/javascript"
                src="https://campaigns.zoho.in/js/zc.iframe.js"
              ></script>
              <iframe
                frameBorder="0"
                id="iframewin"
                width="100%"
                height="100%"
                src="https://toudg-zc1.maillist-manage.in/ua/Optin?od=1a1e3db421c25&zx=1df95ce67d&tD=11ece49102345269&sD=11ece4910236f25b"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <a
        href="https://wa.me/919884824733"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="bi bi-whatsapp"></span>
      </a>

      <section className="footer-wrapper pt-4 bg-dark">
        <div className="footer">
          <div className="container-xl">
            <div className="row">
              <div className="col-6 col-sm-3 col-lg">
                <h4 className="fw-bold">Support</h4>
                <ul className="py-4">
                  <li>
                    <Link title="About Us" to="/aboutus/">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link title="Contact Us" to="/contactus/">
                      Contact Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      title="Voucher Code, Promotions & Offers"
                      to="/promos/"
                    >
                      Offers
                    </Link>
                  </li>
                  <li>
                    <Link title="Motherhost Blog" to="/blog/">
                      Motherhost Blog
                    </Link>
                  </li>
                </ul>
              </div>
              {data.map((item, index) => (
                <div className="col-6 col-sm-3 col-lg" key={index}>
                  <h4 className="fw-bold">{item.node.name}</h4>
                  <ul className="py-4">
                    {item.node.submenu.map((subitem, index) => (
                      <li key={index}>
                        <NavLink title={subitem.title} to={subitem.slug}>
                          {subitem.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              <div className="col-6 col-sm-3 col-lg">
                <h4 className="fw-bold">AFFILIATE PROGRAM</h4>
                <ul className="py-4">
                  <li>
                    <NavLink
                      title="AFFILIATE PROGRAM"
                      to="/affiliate-programs/"
                    >
                      Refer & Earn
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-sm-3 col-lg">
                <h4 className="fw-bold">Support</h4>
                <ul className="py-4">
                  <li>
                    <NavLink title="Whois Support" to="/domains/whois/">
                      WHOIS
                    </NavLink>
                  </li>
                  <li>
                    <a
                      title="Product Support"
                      href="https://my.motherhost.com/submitticket.php?step=2&deptid=2"
                    >
                      Product Support
                    </a>
                  </li>
                  <li>
                    <a
                      title="Domain Support"
                      href="https://my.motherhost.com/submitticket.php?step=2&deptid=2"
                    >
                      Domain Support
                    </a>
                  </li>
                  <li>
                    <a
                      title="Report Abuse"
                      href="https://my.motherhost.com/submitticket.php?step=2&deptid=1"
                    >
                      Report Abuse
                    </a>
                  </li>
                  <li>
                    <a
                      title="Announcement"
                      href="https://my.motherhost.com/announcements.php"
                    >
                      Announcements
                    </a>
                  </li>
                  <li>
                    <NavLink title="Whois Support" to="/help/">
                      Knowledgebase
                    </NavLink>
                  </li>
                </ul>
                <h4 className="fw-bold">ICANN</h4>
                <ul>
                  <li>
                    <a
                      title="Rights and obligations of domain name holders"
                      href="https://www.icann.org/resources/pages/benefits-2013-09-16-en"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Rights and obligations of domain name holders
                    </a>
                  </li>
                  <li>
                    <a
                      title="ICANN documentation for domain name holders"
                      href="https://www.icann.org/resources/pages/educational-2012-02-25-en"
                      target="_blank"
                      rel="noreferrer"
                    >
                      ICANN documentation for domain name holders
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row border-top footer-bottom mt-4 pt-4 ">
              <div className="col-12 col-md-6 copyright">
                <p className=" mb-3">
                  <i className="bi bi-c-circle me-1"></i>
                  2009 - {date} Motherhost. All rights reserved
                </p>

                <div className="nav justify-content-lg-start social ">
                  <LanguageToggle />
                </div>
              </div>
              <div className="col-12 col-md-6 list-unstyled credits">
                <ul className="nav justify-content-lg-end legal mb-3">
                  <li>
                    <Link
                      title="Privacy Policy"
                      to="/legal/affiliate-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Affiliate Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      title="Privacy Policy"
                      to="/legal/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      title="Terms of Services"
                      to="/legal/terms-of-services/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Services
                    </Link>
                  </li>
                </ul>
                <ul className="nav justify-content-center justify-content-lg-end social">
                  <li>
                    <a
                      title="Motherhost Facebook"
                      href="https://www.facebook.com/motherhost"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      title="Motherhost Twitter"
                      href="https://twitter.com/motherhost"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-twitter-x"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      title="Motherhost Linkedin"
                      href="https://www.linkedin.com/company/motherhost"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      title="Motherhost Instrgram"
                      href="https://www.instagram.com/motherhostws/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}

export default Footer
